

<template>
  <TopBarVue />
  <HeaderMenuVue />
  <main id="main">
    <router-view />
  </main>
  <!-- End #main -->
  <FooterComponentVue />

  <!-- <div id="preloader"></div> -->
  <a
    href="#"
    class="back-to-top d-flex align-items-center justify-content-center"
  >
    <i class="bi bi-arrow-up-short"></i>
  </a>
</template>

<script>
import TopBarVue from "./components/TopBar.vue";
import HeaderMenuVue from "./components/HeaderMenu.vue";
import FooterComponentVue from "./components/FooterComponent.vue";
import "./assets/customStyle.css";
export default {
  components: {
    TopBarVue,
    HeaderMenuVue,
    FooterComponentVue,
  },
  setup() {
    return {};
  },
  mounted() {
    let Scripts_Path = [
      "assets/vendor/purecounter/purecounter.js",
      "assets/vendor/aos/aos.js",
      "assets/vendor/bootstrap/js/bootstrap.bundle.min.js",
      "assets/vendor/glightbox/js/glightbox.min.js",
      "assets/vendor/swiper/swiper-bundle.min.js",
      "/Vendor/isotope-layout/isotope.pkgd.min.js",
      "assets/vendor/php-email-form/validate.js",
      "assets/js/main.js",
    ];
    Scripts_Path.forEach((script) => {
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      document.body.appendChild(tag);
    });
  },
};
</script>


<style>
</style>
